export default {"src":"https://images-cdn.curipod.com/d-932c92f6/_next/static/media/wake_county_wcpss.dd36f474.svg","height":67,"width":250};